import _defineProperty from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _FONT_SIZE, _LETTER_SPACING, _LINE_HEIGHT;
import PropTypes from 'prop-types';
export var SIZE = {
  ZERO: 'size0',
  ONE: 'size1',
  TWO: 'size2',
  THREE: 'size3',
  FOUR: 'size4',
  FIVE: 'size5',
  SIX: 'size6'
};
export var SIZES = Object.values(SIZE);
export var FONT_SIZE = (_FONT_SIZE = {}, _defineProperty(_FONT_SIZE, SIZE.ZERO, '24px'), _defineProperty(_FONT_SIZE, SIZE.ONE, '30px'), _defineProperty(_FONT_SIZE, SIZE.TWO, '36px'), _defineProperty(_FONT_SIZE, SIZE.THREE, '48px'), _defineProperty(_FONT_SIZE, SIZE.FOUR, '64px'), _defineProperty(_FONT_SIZE, SIZE.FIVE, '80px'), _defineProperty(_FONT_SIZE, SIZE.SIX, '112px'), _FONT_SIZE);
export var LETTER_SPACING = (_LETTER_SPACING = {}, _defineProperty(_LETTER_SPACING, SIZE.ZERO, '-0.02em'), _defineProperty(_LETTER_SPACING, SIZE.ONE, '-0.02em'), _defineProperty(_LETTER_SPACING, SIZE.TWO, '-0.02em'), _defineProperty(_LETTER_SPACING, SIZE.THREE, '-0.02em'), _defineProperty(_LETTER_SPACING, SIZE.FOUR, '-0.02em'), _defineProperty(_LETTER_SPACING, SIZE.FIVE, '-0.02em'), _defineProperty(_LETTER_SPACING, SIZE.SIX, '-0.03em'), _LETTER_SPACING);
export var LINE_HEIGHT = (_LINE_HEIGHT = {}, _defineProperty(_LINE_HEIGHT, SIZE.ZERO, '1.2'), _defineProperty(_LINE_HEIGHT, SIZE.ONE, '1.1'), _defineProperty(_LINE_HEIGHT, SIZE.TWO, '1.1'), _defineProperty(_LINE_HEIGHT, SIZE.THREE, '1.1'), _defineProperty(_LINE_HEIGHT, SIZE.FOUR, '1.1'), _defineProperty(_LINE_HEIGHT, SIZE.FIVE, '1'), _defineProperty(_LINE_HEIGHT, SIZE.SIX, '1'), _LINE_HEIGHT);
export var propTypes = {
  children: PropTypes.node,
  element: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  size: PropTypes.oneOf(SIZES),
  extraSmallViewportsSize: PropTypes.oneOf(SIZES),
  smallViewportsSize: PropTypes.oneOf(SIZES),
  mediumViewportsSize: PropTypes.oneOf(SIZES),
  largeViewportsSize: PropTypes.oneOf(SIZES)
};
export var defaultProps = {
  element: 'h1',
  size: SIZE.THREE,
  extraSmallViewportsSize: null,
  smallViewportsSize: null,
  mediumViewportsSize: null,
  largeViewportsSize: null
};